
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as inner from '../inner'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {OrderUpdate2Response} from './OrderUpdate2Response';
import {OrderUpdate} from './OrderUpdate';
import {FieldModelOrderUpdate} from './OrderUpdate';
import {TransactionType} from '../entity/TransactionType';
import {FieldModelTransactionType} from '../entity/TransactionType';
import {TradeEvent} from '../entity/TradeEvent';
import {FieldModelTradeEvent} from '../entity/TradeEvent';

/**
 * OrderUpdate2Request struct
 */
class OrderUpdate2Request extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!OrderUpdate=} order
   * @param {!UUID=} accountGroupId
   * @param {!TransactionType=} transactionType
   * @param {!Array=} tradeEvents
   * @param {string=} externalClientId
   * @param {number=} transactionTradeVolumeUSD
   * @constructor
   */
  constructor (parent = new Request(), order = new OrderUpdate(), accountGroupId = new UUID(), transactionType = new TransactionType(), tradeEvents = [], externalClientId = null, transactionTradeVolumeUSD = null) {
    super()
    super.copy(parent)
    this.Order = order
    this.AccountGroupId = accountGroupId
    this.TransactionType = transactionType
    this.TradeEvents = tradeEvents
    this.ExternalClientId = externalClientId
    this.TransactionTradeVolumeUSD = transactionTradeVolumeUSD
  }

  /**
   * Copy struct (shallow copy)
   * @this {!OrderUpdate2Request}
   * @param {!OrderUpdate2Request} other Other struct
   * @returns {!OrderUpdate2Request} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.Order != null) {
      this.Order = OrderUpdate.fromObject(other.Order)
    } else {
      this.Order = null
    }
    if (other.AccountGroupId != null) {
      this.AccountGroupId = new UUID(other.AccountGroupId)
    } else {
      this.AccountGroupId = null
    }
    if (other.TransactionType != null) {
      this.TransactionType = TransactionType.fromObject(other.TransactionType)
    } else {
      this.TransactionType = null
    }
    if (other.TradeEvents != null) {
      this.TradeEvents = []
      for (let item of other.TradeEvents) {
        if (item != null) {
          let tempItem
          tempItem = TradeEvent.fromObject(item)
          this.TradeEvents.push(tempItem)
        } else {
          this.TradeEvents.push(null)
        }
      }
    } else {
      this.TradeEvents = null
    }
    if (other.ExternalClientId != null) {
      this.ExternalClientId = other.ExternalClientId
    } else {
      this.ExternalClientId = null
    }
    if (other.TransactionTradeVolumeUSD != null) {
      this.TransactionTradeVolumeUSD = other.TransactionTradeVolumeUSD
    } else {
      this.TransactionTradeVolumeUSD = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!OrderUpdate2Request}
   * @returns {!OrderUpdate2Request} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new OrderUpdate2RequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new OrderUpdate2RequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!OrderUpdate2Request}
   * @param {!OrderUpdate2Request} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof OrderUpdate2Request)) {
      throw new TypeError('Instance of OrderUpdate2Request is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!OrderUpdate2Request}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      Order: ((this.Order != null) ? this.Order : null),
      AccountGroupId: ((this.AccountGroupId != null) ? this.AccountGroupId.toString() : null),
      TransactionType: ((this.TransactionType != null) ? this.TransactionType : null),
      TradeEvents: ((this.TradeEvents != null) ? Array.from(this.TradeEvents, item => ((item != null) ? item : null)) : null),
      ExternalClientId: ((this.ExternalClientId != null) ? this.ExternalClientId : null),
      TransactionTradeVolumeUSD: ((this.TransactionTradeVolumeUSD != null) ? this.TransactionTradeVolumeUSD : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return OrderUpdate2Request.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!OrderUpdate2Request} other Object value
   * @returns {!OrderUpdate2Request} Created struct
   */
  static fromObject (other) {
    return new OrderUpdate2Request().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!OrderUpdate2Request}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return OrderUpdate2Request.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!OrderUpdate2Request}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 4061
  }
}

export { OrderUpdate2Request };

/**
 * Fast Binary Encoding OrderUpdate2Request field model
 */
class FieldModelOrderUpdate2Request extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.Order = new FieldModelOrderUpdate(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.AccountGroupId = new fbe.FieldModelUUID(buffer, this.Order.fbeOffset + this.Order.fbeSize)
    this.TransactionType = new FieldModelTransactionType(buffer, this.AccountGroupId.fbeOffset + this.AccountGroupId.fbeSize)
    this.TradeEvents = new fbe.FieldModelVector(new FieldModelTradeEvent(buffer, this.TransactionType.fbeOffset + this.TransactionType.fbeSize), buffer, this.TransactionType.fbeOffset + this.TransactionType.fbeSize)
    this.ExternalClientId = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.TradeEvents.fbeOffset + this.TradeEvents.fbeSize), buffer, this.TradeEvents.fbeOffset + this.TradeEvents.fbeSize)
    this.TransactionTradeVolumeUSD = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.ExternalClientId.fbeOffset + this.ExternalClientId.fbeSize), buffer, this.ExternalClientId.fbeOffset + this.ExternalClientId.fbeSize)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelOrderUpdate2Request}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelOrderUpdate2Request}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelOrderUpdate2Request}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.Order.fbeSize + this.AccountGroupId.fbeSize + this.TransactionType.fbeSize + this.TradeEvents.fbeSize + this.ExternalClientId.fbeSize + this.TransactionTradeVolumeUSD.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelOrderUpdate2Request}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.Order.fbeExtra + this.AccountGroupId.fbeExtra + this.TransactionType.fbeExtra + this.TradeEvents.fbeExtra + this.ExternalClientId.fbeExtra + this.TransactionTradeVolumeUSD.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelOrderUpdate2Request}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelOrderUpdate2Request.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelOrderUpdate2Request}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 4061
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelOrderUpdate2Request}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelOrderUpdate2Request}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Order.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Order.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Order.fbeSize

    if ((fbeCurrentSize + this.AccountGroupId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountGroupId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountGroupId.fbeSize

    if ((fbeCurrentSize + this.TransactionType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TransactionType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TransactionType.fbeSize

    if ((fbeCurrentSize + this.TradeEvents.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TradeEvents.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TradeEvents.fbeSize

    if ((fbeCurrentSize + this.ExternalClientId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ExternalClientId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExternalClientId.fbeSize

    if ((fbeCurrentSize + this.TransactionTradeVolumeUSD.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TransactionTradeVolumeUSD.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TransactionTradeVolumeUSD.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelOrderUpdate2Request}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelOrderUpdate2Request}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelOrderUpdate2Request}
   * @param {!OrderUpdate2Request} fbeValue Default value, defaults is new OrderUpdate2Request()
   * @returns {!OrderUpdate2Request} OrderUpdate2Request value
   */
  get (fbeValue = new OrderUpdate2Request()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelOrderUpdate2Request}
   * @param {!OrderUpdate2Request} fbeValue OrderUpdate2Request value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Order.fbeSize) <= fbeStructSize) {
      fbeValue.Order = this.Order.get()
    } else {
      fbeValue.Order = new OrderUpdate()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Order.fbeSize

    if ((fbeCurrentSize + this.AccountGroupId.fbeSize) <= fbeStructSize) {
      fbeValue.AccountGroupId = this.AccountGroupId.get()
    } else {
      fbeValue.AccountGroupId = new UUID()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountGroupId.fbeSize

    if ((fbeCurrentSize + this.TransactionType.fbeSize) <= fbeStructSize) {
      fbeValue.TransactionType = this.TransactionType.get()
    } else {
      fbeValue.TransactionType = new TransactionType()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TransactionType.fbeSize

    if ((fbeCurrentSize + this.TradeEvents.fbeSize) <= fbeStructSize) {
      this.TradeEvents.get(fbeValue.TradeEvents)
    } else {
      fbeValue.TradeEvents.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TradeEvents.fbeSize

    if ((fbeCurrentSize + this.ExternalClientId.fbeSize) <= fbeStructSize) {
      fbeValue.ExternalClientId = this.ExternalClientId.get()
    } else {
      fbeValue.ExternalClientId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExternalClientId.fbeSize

    if ((fbeCurrentSize + this.TransactionTradeVolumeUSD.fbeSize) <= fbeStructSize) {
      fbeValue.TransactionTradeVolumeUSD = this.TransactionTradeVolumeUSD.get()
    } else {
      fbeValue.TransactionTradeVolumeUSD = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TransactionTradeVolumeUSD.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelOrderUpdate2Request}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelOrderUpdate2Request}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelOrderUpdate2Request}
   * @param {!OrderUpdate2Request} fbeValue OrderUpdate2Request value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelOrderUpdate2Request}
   * @param {OrderUpdate2Request} fbeValue OrderUpdate2Request value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.Order.set(fbeValue.Order)
    this.AccountGroupId.set(fbeValue.AccountGroupId)
    this.TransactionType.set(fbeValue.TransactionType)
    this.TradeEvents.set(fbeValue.TradeEvents)
    this.ExternalClientId.set(fbeValue.ExternalClientId)
    this.TransactionTradeVolumeUSD.set(fbeValue.TransactionTradeVolumeUSD)
  }
}

export { FieldModelOrderUpdate2Request };

/**
 * Fast Binary Encoding OrderUpdate2Request model
 */
class OrderUpdate2RequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelOrderUpdate2Request(this.buffer, 4)
  }

  /**
   * Get the OrderUpdate2Request model
   * @this {!OrderUpdate2RequestModel}
   * @returns {!FieldModelOrderUpdate2Request} model OrderUpdate2Request model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!OrderUpdate2RequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!OrderUpdate2RequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return OrderUpdate2RequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!OrderUpdate2RequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelOrderUpdate2Request.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!OrderUpdate2RequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!OrderUpdate2RequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!OrderUpdate2RequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!OrderUpdate2RequestModel}
   * @param {!OrderUpdate2Request} value OrderUpdate2Request value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!OrderUpdate2RequestModel}
   * @param {!OrderUpdate2Request} value OrderUpdate2Request value, defaults is new OrderUpdate2Request()
   * @return {!object} Deserialized OrderUpdate2Request value and its size
   */
  deserialize (value = new OrderUpdate2Request()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new OrderUpdate2Request(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new OrderUpdate2Request(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!OrderUpdate2RequestModel}
   * @param {!number} prev Previous OrderUpdate2Request model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { OrderUpdate2RequestModel };
OrderUpdate2Request.__has_response = true;
OrderUpdate2Request.__response_class = OrderUpdate2Response;
